import axios from "axios";

// Job Simulations API. Same-origin relative paths (cookie/session auth rides
// along, like every other service here). Each function unwraps the server's
// { serverResponse, data } envelope and returns the `data` payload; axios
// throws on non-2xx so the thunks can map errors.
const API = "/api/simulations";

const unwrap = (res) => res.data.data;

const getCatalog = async () => unwrap(await axios.get(`${API}`));

const getSimulation = async (slug) => unwrap(await axios.get(`${API}/${slug}`));

const getBoard = async (slug) => unwrap(await axios.get(`${API}/${slug}/board`));

const getCard = async (slug, cardKey) =>
  unwrap(await axios.get(`${API}/${slug}/cards/${cardKey}`));

const startCard = async (slug, cardKey) =>
  unwrap(await axios.post(`${API}/${slug}/cards/${cardKey}/start`));

const resolveCard = async (slug, cardKey) =>
  unwrap(await axios.post(`${API}/${slug}/cards/${cardKey}/resolve`));

const submitQa = async (slug, cardKey) =>
  unwrap(await axios.post(`${API}/${slug}/cards/${cardKey}/qa`));

const getQaStatus = async (slug, cardKey) =>
  unwrap(await axios.get(`${API}/${slug}/cards/${cardKey}/qa/status`));

const postComment = async (slug, cardKey, body) =>
  unwrap(await axios.post(`${API}/${slug}/cards/${cardKey}/comments`, { body }));

const requestCredentials = async (slug, cardKey) =>
  unwrap(await axios.post(`${API}/${slug}/cards/${cardKey}/credentials`));

const getWiki = async (slug) => unwrap(await axios.get(`${API}/${slug}/wiki`));

const getWikiPage = async (slug, pageSlug) =>
  unwrap(await axios.get(`${API}/${slug}/wiki/${pageSlug}`));

const simulationService = {
  getCatalog,
  getSimulation,
  getBoard,
  getCard,
  startCard,
  resolveCard,
  submitQa,
  getQaStatus,
  postComment,
  requestCredentials,
  getWiki,
  getWikiPage,
};

export default simulationService;
